import React from "react";
import "../supplierAndManufacturers.scss";
import { HeadersTabsValues } from "..";

const HeaderTabs = ({
  tabsList = HeadersTabsValues,
  selectedTab = HeadersTabsValues[0],
  setSelectedTab = () => { }
}) => {
  return (
    <div className="headerTabs">
      {
        tabsList?.map((tabItem) => {
          return (
            <TabItem
              key={tabItem?.pageId}
              name={tabItem?.name}
              isSelected={tabItem?.pageId === selectedTab?.pageId}
              onClick={() => { setSelectedTab(tabItem) }}
            />
          )
        })
      }
    </div>
  );
};

export default HeaderTabs;

export const TabItem = ({
  name = '',
  isSelected = false,
  onClick = () => { }
}) => (
  <div className={`tabItem ${isSelected ? 'selected' : ''}`} onClick={onClick}>{name}</div>
)
